/* eslint-disable react/require-default-props */
import { Dialog } from 'primereact/dialog';

import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

function ConfirmChangeProgram({
  isVisible,
  setIsVisible,
  currentData,
  handleConfirmChange,
  programName,
  loading,
  type,
}) {
  const { t } = useTranslation();

  const footerConfirmationSubmit = () => (
    <div>
      <Button
        label={t('projectProposal.cancel')}
        className="w-7rem"
        severity="danger"
        onClick={() => {
          setIsVisible(false);
        }}
        autoFocus
      />
      <Button
        label={t('projectProposal.ok')}
        className="w-7rem"
        severity="info"
        disabled={loading}
        onClick={handleConfirmChange}
      />
    </div>
  );

  return (
    <Dialog
      header={<p className="text-yellow-500">{t('projectProposal.changeProgram.confirm')}</p>}
      visible={isVisible}
      position="center"
      style={{ width: '400px' }}
      onHide={() => {
        setIsVisible(false);
      }}
      draggable={false}
      footer={footerConfirmationSubmit}
    >
      <p className="text-lg font-bold">
        {type === 'proposal' ? t('proposal.label') : t('projectProposal.label')}:{' '}
        {t('lang') === 'vi' ? currentData?.vietnameseName : currentData?.englishName}
      </p>
      <p className="text-lg">
        <span className="font-bold">{t('projectProposal.changeProgram.previous')}:</span>{' '}
        {currentData?.name ?? ''}
      </p>
      <p className="text-lg">
        <span className="font-bold">{t('projectProposal.changeProgram.new')}:</span>{' '}
        {programName ?? ''}
      </p>
    </Dialog>
  );
}

ConfirmChangeProgram.propTypes = {
  isVisible: PropTypes.bool,
  setIsVisible: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  currentData: PropTypes.object,
  handleConfirmChange: PropTypes.func,
  programName: PropTypes.string,
  loading: PropTypes.bool,
  type: PropTypes.string,
};

ConfirmChangeProgram.defaultProps = {
  isVisible: false,
  currentData: null,
  programName: '',
};

export default ConfirmChangeProgram;
